import { render } from "./materialHome.vue?vue&type=template&id=27a6b3a4&scoped=true"
import script from "./materialHome.vue?vue&type=script&lang=js"
export * from "./materialHome.vue?vue&type=script&lang=js"

import "./materialHome.vue?vue&type=style&index=0&id=27a6b3a4&lang=scss&scoped=true"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a6b3a4"]])

export default __exports__